import styled, {css, FlattenSimpleInterpolation} from 'styled-components'
import {BrandLogoHollow, media as _media, UnstyledButton} from '@modifi/ui'
import {white, seaNavy, airBlue} from '@modifi/colors'

import STYLE_CONSTANTS from '../../../styles/constants'
import Link from '../../../features/common/link'

type mediaType = Record<string, any>

const media = _media as mediaType

export const FooterWrapper = styled.footer`
  padding: 60px 0 60px;
  background: linear-gradient(to left, ${seaNavy} 1.05%, ${airBlue} 96%);
  color: ${white};
  ${media.tablet`
    padding: 80px 0 80px;
  `}
  ${media.desktop`
    padding: 120px 0 100px;
  `}
`

export const LogoLink = styled(Link)`
  display: block;
  height: 20px;
  width: 121px;
  margin: 40px 0 20px;

  svg {
    height: 100%;
    width: auto;
  }

  ${media.lg`
    margin: 40px 0 50px;
    height: 24px;
    width: 147px;
  `}
`

export const SocialLinks = styled.div`
  display: flex;
  margin: 30px 0 40px;
`

export const StyledSocialLink = styled.a`
  height: 24px;
  width: 24px;

  & + & {
    margin-left: 8px;
  }

  > svg {
    height: 100%;
    width: 100%;
  }
`

export const CTAWrapper = styled.div`
  margin: 40px 0 60px;
  ${media.xl`
    display: flex;
    justify-content: flex-start;
  `}
`

export const Copyright = styled.div`
  font-size: 14px;
  margin: 0;
`

export const CookieSettingsButton = styled(UnstyledButton)`
  &:hover,
  &:focus {
    cursor: pointer;
  }
`

type StyledFooterSectionProps = {
  first?: boolean
  second?: boolean
}

export const StyledFooterSection = styled.div<StyledFooterSectionProps>`
  display: block;
  ${({first}): FlattenSimpleInterpolation | string =>
    first
      ? css`
          ${CTAWrapper} {
            display: none;
          }
          ${media.lg`
   ${CTAWrapper} { display: flex;}
`}
        `
      : ''}

  ${({second}): FlattenSimpleInterpolation | string =>
    second
      ? css`
          margin-top: 32px;
          ${CTAWrapper}, ${SocialLinks} {
            display: none;
          }

          ${media.lg`
          margin-top: 0;
        display: none;
      `}
        `
      : ''}
`

export const Nav = styled.nav`
  display: flex;
  flex-direction: column;
`

export const H4 = styled.h4`
  font-size: 18px;
  font-weight: ${STYLE_CONSTANTS.FONT_WEIGHT_BOLD};
  margin: 40px 0 20px;
  ${media.lg`
    margin-top: 2px
  `}
`

export const NavItem = styled.div`
  margin: 11px 0;
  overflow: hidden;
  text-overflow: ellipsis;

  > .fake-link {
    cursor: pointer;
  }

  > a,
  .fake-link {
    color: ${white};
    text-decoration: none;
  }
`

export const UpdatedBrandLogoHollow = styled(BrandLogoHollow)`
  ${media.lg`
    width: 100%;
  `}
  ${media.xl`
    width: auto;
  `}
`

export const QRCodeWrapper = styled.div`
  display: flex;
  margin: 30px 0 40px;
`
